import { render, staticRenderFns } from "./home-screen.vue?vue&type=template&id=401273da&"
import script from "./home-screen.vue?vue&type=script&lang=ts&"
export * from "./home-screen.vue?vue&type=script&lang=ts&"
import style0 from "./home-screen.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports